require('../../style/base.less');
require('../../info/index.less');
require('../../icon/index.less');
require('../../radio/index.less');
require('../../tag/index.less');
require('../../cell/index.less');
require('../../loading/index.less');
require('../../button/index.less');
require('../../radio-group/index.less');
require('../index.less');